import React, { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import * as dayjs from "dayjs";
import * as utc from "dayjs/plugin/utc";
import { getMaxMonthYear, getMinMonthYear } from "../../../../utils/common";
import { ActivityType } from "../../Masters/Master.constants";
import FormRenderer, { ComponentMapper, componentTypes, FormTemplate } from "../../../common/FormRenderer";
import { ACTIVITY_TYPE, API_DELIMITER, ERROR_MESSAGES } from "../../../../utils/constants";
import { MONTHS_ENUM } from "../../../common/Constants";
import { useCheckEligibilityGenerateBulkToDoAuditReport, useGenerateBulkToDoAuditReport, useGetToDoVendorAuditCounts, useGetUserVendorCategoriesByLocations, useGetUserVendorsByCategoryandLocationIds, useGetVendor, useGetVendorAssociateCompanies, useGetVendorCategoriresCompanies, useGetVendorHeirarchyRecords, useGetVendorLocations } from "../../../../backend/masters";
import { validatorTypes } from "@data-driven-forms/react-form-renderer";
import { ResponseModel } from "../../../../models/responseModel";
import { toast } from "react-toastify";
import { getUserDetails } from "../../../../backend/auth";
import { AxiosError } from "axios";
import Icon from "../../../common/Icon";
import PageLoader from "../../../shared/PageLoader";
dayjs.extend(utc as any);

function VendorAuditBulkDownloadModal(this: any, { onSubmit, onCancel, previousFilters }: any) {
    const [filter, setFilter] = useState<any>({ hideButtons: true });

    const [company, setCompany] = useState<any>(null);
    const [associateCompany, setAssociateCompany] = useState<any>(null);
    const [associateCompanies, setAssociateCompanies] = useState<any>(null);
    const [vendorLocations, setVendorLocations] = useState<any>(null);
    const [locations, setLocations] = useState<any>(null);
    const [monthYear, setMonthYear] = useState<any>(null);
    const [vendorCategories, setVendorCategories] = useState<any>(null);
    const [vendorRegistrations, setVendorRegistrations] = useState<any>(null);
    const [auditCounts, setAuditCounts] = useState<any>(null);
    const [canGenerate, setCanGenerate] = useState<boolean>(true);
    const user = getUserDetails();

    const { companies, isFetching }: any = useGetVendorHeirarchyRecords({
    filters: {
        user_id_eq: user.user_id
    },
    // includes: INCLUDE_USER_COMPANY_ASSOCIATIONS
    });

    const { vendorCategoriesByLocations, isFetching: fetchingVendorCategories } =
    useGetUserVendorCategoriesByLocations(
        {
            company_id: (company || {}).value,
            associate_company_id: (associateCompany || {}).value,
            location_ids: (locations || []).map((l: any) => (l || {}).value)
        },
        !!(company || {}).value && !! (associateCompany || {}).value || !!(locations || []).map((l: any) => (l || {}).value).length
    );

    const { getvendorsByCategoryAndLocationIds, isFetching: fetchingVendors } = useGetUserVendorsByCategoryandLocationIds(
        {
            company_id: (company || {}).value,
            associate_company_id: (associateCompany || {}).value,
            location_ids: (locations || []).map((l: any) => (l || {}).value),
            vendor_category_ids: (vendorCategories || []).map((vc: any) => (vc || {}).value)
        },
        !!(company || {}).value && !! (associateCompany || {}).value || !!(locations || []).map((l: any) => (l || {}).value).length && !!(vendorCategories || []).map((vc: any) => (vc || {}).value).length
    );

    const { getToDoVendorAuditCounts, error, fetchingAuditCounts } = useGetToDoVendorAuditCounts((response: ResponseModel) => {
        if(response instanceof AxiosError){
            const data = (((response || {}).response || {}).data || {}).errors;
            const errors = Object.values(data || {});
            toast.error(errors.join(", "));
        } else {
            setAuditCounts(response.data);
        }
    }, errorCallback);

    const { checkEligibilityGenerateBulkToDoAuditReport, error: checkEligibilityError, checkingEligibility } = useCheckEligibilityGenerateBulkToDoAuditReport((response: ResponseModel) => {
        if(response instanceof AxiosError){
            const data = (((response || {}).response || {}).data || {}).errors;
            const errors = Object.values(data || {});
            toast.error(errors.join(", "));
        } else {
            setCanGenerate((response.data || {}).canGenerate);
        }
    }, errorCallback);

    const { generateBulkToDoAuditReport, error: generateError, generatingAuditReport } = useGenerateBulkToDoAuditReport((response: ResponseModel) => {
        if(response instanceof AxiosError){
            const data = (((response || {}).response || {}).data || {}).errors;
            const errors = Object.values(data || {});
            toast.error(errors.join(", "));
        } else {
            toast.success("Preparing your ZIP. You will receive an e-mail when it’s ready.");
            onSubmit();
            onCancel();
        }
    }, errorCallback);

    useEffect(() => {
        setFilter({...filter, ...previousFilters});
        setCompany(previousFilters.company || null);
        setAssociateCompany(previousFilters.associateCompany || null);
        setMonthYear(previousFilters.monthYear || null);
        setLocations(previousFilters.locations || null);
        setVendorCategories(previousFilters.vendorCategories || null);
        setVendorRegistrations(previousFilters.vendorRegistartions || null);
        if(previousFilters.company){
            const _company = companies.find((c: any) => c.id == previousFilters.company.value);
            setAssociateCompanies(_company.associate_companies);
        }
        if(previousFilters.associateCompany){
            const _company = companies.find((c: any) => c.id == previousFilters.company.value);
            const _associateCompany = _company.associate_companies.find((c: any) => c.id == previousFilters.associateCompany.value);
            setVendorLocations(_associateCompany.locations);
        }
    }, [previousFilters]);

    function errorCallback() {
        toast.error(ERROR_MESSAGES.DEFAULT);
    }

    function onCompanyChange(e: any) {
        if(company && company.value == e.value){
            return;
        }
        const _company = companies.find((c: any) => c.id == e.value)
        setAssociateCompanies(_company.associate_companies);
        setCompany(e);
        setAssociateCompany(null);
        setLocations(null);
        setVendorCategories(null);
        setVendorRegistrations(null);
        setTimeout(() => {
            setFilter({...filter, company: e, associateCompany: null, locations: null, vendorCategories: null, vendorRegistrations: null});
        }, 100);
    }

    function onAssociateCompanyChange(e: any) {
        if(associateCompany && associateCompany.value == e.value){
            return;
        }
        const _company = companies.find((c: any) => c.id == company.value)
        const _associateCompany = _company.associate_companies.find((c: any) => c.id == e.value)
        setVendorLocations(_associateCompany.locations);
        setAssociateCompany(e);
        setLocations(null);
        setVendorCategories(null);
        setVendorRegistrations(null);
        setTimeout(() => {
            setFilter({...filter, associateCompany: e, locations: null, vendorCategories: null, vendorRegistrations: null});
        }, 100);
    }

    function onMonthYearChange(event: any) {
        setMonthYear(event);
        setFilter({ ...filter, monthYear: event ? event.toDate() : undefined })
    }

    function onLocationsChange(e: any) {
        setLocations(e);
        setVendorCategories(null);
        setVendorRegistrations(null);
        setTimeout(() => {
            setFilter({...filter, locations: e, vendorCategories: null, vendorRegistrations: null});
        }, 100);
    }

    function onVendorCategoryChange(e: any) {
        setVendorCategories(e);
        setVendorRegistrations(null);
        setTimeout(() => {
            setFilter({...filter, vendorCategories: e, vendorRegistrations: null});
        }, 100);
    }

    function onVendorRegistrationChange(e: any) {
        setVendorRegistrations(e);
        setTimeout(() => {
            setFilter({...filter, vendorRegistrations: e});
        }, 100);
    }

    const schema: any = {
        fields: [
            {
                component: componentTypes.SELECT,
                name: 'company',
                label: 'Company Name',
                options: (companies || []).map((x: any) => {
                    return { value: x.id, label: x.name };
                }),
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                isLoading: isFetching,
                onChange: onCompanyChange.bind(this)
            },
            {
                component: componentTypes.SELECT,
                name: 'associateCompany',
                label: 'Associate Company',
                options: Array.isArray(associateCompanies)
                    ? associateCompanies.map((x: any) => ({
                        value: x.id,
                        label: x.name,
                    }))
                    : [],
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                isLoading: isFetching,
                isDisabled: !Boolean(company),
                onChange: onAssociateCompanyChange.bind(this)
            },
            {
                component: componentTypes.MONTH_PICKER,
                name: 'monthYear',
                label: 'Audit Month and Year',
                minDate: getMinMonthYear(),
                maxDate: getMaxMonthYear(),
                range: false,
                clearable: false,
                disabled: !Boolean(associateCompany),
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                onChange: onMonthYearChange.bind(this),
                initialValue: filter.monthYear
            },
            {
                component: componentTypes.SELECT,
                name: 'locations',
                label: 'Locations',
                options: Array.isArray(vendorLocations)
                    ? vendorLocations.map((x: any) => ({
                        value: x.id,
                        label: x.name,
                    }))
                    : [],
                isDisabled: !Boolean(associateCompany),
                isLoading: isFetching,
                isMulti: true,
                onChange: onLocationsChange.bind(this)
            },
            {
                component: componentTypes.SELECT,
                name: "vendorCategories",
                label: "Vendor Categories",
                options: (vendorCategoriesByLocations || []).map((x: any) => {
                return { value: x.id, label: x.name };
                }),
                isDisabled: !Boolean(locations),
                isLoading: fetchingVendorCategories,
                isMulti: true,
                onChange: onVendorCategoryChange.bind(this),
            },
            {
                component: componentTypes.SELECT,
                name: "vendorRegistrations",
                label: "Vendors",
                options: Array.isArray(getvendorsByCategoryAndLocationIds)
                    ? getvendorsByCategoryAndLocationIds.map((x: any) => ({
                        value: x.id,
                        label: x.vendor_name,
                    }))
                    : [],
                isDisabled: !Boolean(vendorCategories),
                isLoading: fetchingVendors,
                isMulti: true,
                onChange: onVendorRegistrationChange.bind(this),
            }
        ]
    }

    function debugForm(_form: any) {
        setFilter(_form.values);
    }

    function isInvalid() {
        return !company || !associateCompany || !monthYear;
    }

    function submit() {
        if(isInvalid()){
            toast.error("Please select Company, Associate Company and Month–Year.");
            return;
        }
        if(auditCounts){
            generateBulkReport();
        } else {
            getAuditCounts();
        }
    }
    
    function getAuditCounts() {
        const _payload: any = getPayload();
        getToDoVendorAuditCounts(_payload);
        // checkEligibilityGenerateBulkToDoAuditReport(_payload);
    }
    
    function generateBulkReport() {
        const _payload: any = getPayload();
        generateBulkToDoAuditReport(_payload);
    }

    function getPayload() {
        const { company, associateCompany, monthYear, locations, vendorCategories, vendorRegistrations
        } = filter;
        const _payload: any = {};
        _payload.company_id = ((company || {}).value || "");
        _payload.associate_company_id = ((associateCompany || {}).value || "");
        const date = new Date(monthYear);
        const month = MONTHS_ENUM[date.getMonth()];
        const year = date.getFullYear();
        _payload.month = month;
        _payload.year = `${year}`;
        _payload.location_ids = (locations || []).map((l: any) => (l || {}).value);
        _payload.vendor_category_ids = (vendorCategories || []).map((l: any) => (l || {}).value);
        _payload.vendor_registration_ids = (vendorRegistrations || []).map((l: any) => (l || {}).value);
        _payload.auditor_id = getUserDetails().userid;
        return _payload;
    }

    function handleCancel() {
        // need to discuss this logic
        onCancel();
        return;
        if(auditCounts){
            setAuditCounts(null);
        } else {
            onCancel();
        }
    }

    return (<>
        <Modal show={true} backdrop="static" animation={false} dialogClassName="drawer" size="lg">
            <Modal.Header closeButton={true} onHide={onCancel}>
                <Modal.Title className="bg">Bulk Report Download</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex justify-content-start">
                    {!auditCounts && <div className="col-12">
                        <form>
                            <div className="row mt-3">
                                <div className="col-12">
                                    <FormRenderer FormTemplate={FormTemplate}
                                        initialValues={filter}
                                        componentMapper={ComponentMapper}
                                        schema={schema}
                                        debug={debugForm}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>}
                    {auditCounts && <div className="col-12">
                        <div className="custom-card">
                            <div className="stat">
                                <div className="stat-value">{auditCounts.completed_count + auditCounts.incomplete_count}</div>
                                <div className="stat-label">Total Audits</div>
                            </div>
                            <div className="divider"></div>
                            <div className="stat">
                                <div className="stat-value">{auditCounts.completed_count}</div>
                                <div className="stat-label">Completed Audits</div>
                            </div>
                            <div className="divider"></div>
                            <div className="stat">
                                <div className="stat-value">{auditCounts.incomplete_count}</div>
                                <div className="stat-label">Incomplete Audits</div>
                            </div>
                        </div>
                    </div>}
                </div>
            </Modal.Body>
            {false && <div className="text-center py-3" style={{cursor: "pointer"}}>
                <a className="px-2" style={{color: "#2965AD", fontSize: "16px"}}>Download Excel Sheet of Incomplete Audits</a>
                <Icon name={'download'} />
            </div>}
            {auditCounts && auditCounts.completed_count > 0 && !canGenerate && <div className="text-center py-3 px-2" style={{color: "red"}}>Bulk report generation was already triggered with these parameters in the last 1 hour.</div>}
            {auditCounts && auditCounts.completed_count == 0 && <div className="text-center py-3 px-2" style={{color: "red"}}>Cannot generate reports as there are 0 completed audits.</div>}
            <Modal.Footer className="d-flex justify-content-between">
                <Button variant="outline-secondary" onClick={handleCancel} className="btn btn-outline-secondary">
                    Cancel
                </Button>
                <div>
                    {!auditCounts && <Button variant="primary" onClick={submit}>Filter</Button>}
                    {auditCounts && <Button variant="primary" onClick={submit} disabled={(auditCounts && auditCounts.completed_count > 0 && !canGenerate) || (auditCounts && auditCounts.completed_count == 0)}>Download</Button>}
                </div>
            </Modal.Footer>
        </Modal>
        {(fetchingAuditCounts || generatingAuditReport) && <PageLoader />}
    </>)
}

export default VendorAuditBulkDownloadModal;